declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initPixel(pixelId: string) {
  if (window.fbq) return

  const fbq = function (...args: unknown[]) {
    if ((fbq as any).callMethod) {
      ;(fbq as any).callMethod.apply(fbq, args)
    } else {
      ;(fbq as any).queue.push(args)
    }
  } as any

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = [] as unknown[]

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  // Load the Facebook pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', pixelId)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(data?: Record<string, unknown>) {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', data)
  }
}
